import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from 'react-redux';
import moment from 'moment';
import "moment/min/locales.min";  // without this line momentInstanse.locale doesn't work!

import * as actions from '../../../actions';
import * as actionTypes from './../../../constants/actionTypes';
import {setSendEmailCheckboxes, toggleShowJobBoardLogEntryPopup} from "../../JobBoard/JobBoardActions";
import CheckBox from "../CheckBox";
import {toggleArrayValue} from "../../FeatureCreator/FeaturesFilters/filtersFunctions";
import {SEND_EMAIL_CHECKBOXES} from "../../JobBoard/JobBoardReducer";

const emailCheckboxesTranslates = {
  "sendCustomerEmail": "account.title.customer",
  "sendFabricatorEmail": "account.title.fabricator",
  "sendSalesPersonEmail": "account.additionalInfo.salesPerson",
}

class JobBoardLog extends PureComponent {

  saveBtn = null;

  state = {
    saveButtonClicked: false
  }

  handleChange = (ev) => {
    this.props.handleTextChange(ev.target.value);
  }

  getTitle = () => {
    const {intl, action, logEntry} = this.props
    if (action === "changeLeadType" || (action === "update" && logEntry.type === "ChangeLeadType")) {
      return intl.formatMessage({id: "jobBoard.jobLeadType"}) + ": " + this.props.status
    } else if (action === "changeJobStatus" || (action === "update" && logEntry.type === "ChangeJobStatus")) {
      return intl.formatMessage({id: "jobBoard.jobStatus"}) + ": " + this.props.status
    } else if (action === "freeText") {
      return intl.formatMessage({id: "jobBoard.changeStatusPopup.addNoteTitle"})
    } else {
      return action
    }
  };

  getTimeNow = () => {
    const {intl} = this.props;
    const momentInstanse = moment();
    momentInstanse.locale(intl.locale.split("-")[0]);
    return momentInstanse.format('MMMM D @h:mm a')
  }

  handleSaveClick = () => {
    const {changeJobStatus} = this.props;
    if (!this.state.saveButtonClicked) {
      this.saveBtn.setAttribute("disabled", "disabled");
      this.setState({
        saveButtonClicked: true
      }, () => {
        changeJobStatus();
      })
    }
  }

  render() {

    const {logPopupOpened, action, logEntry, handleCancel, sendEmailCheckboxes, setSendEmailCheckboxes, intl} = this.props;

    if (!logPopupOpened) {
      return null
    }

    // const saveDisabled = logEntry.message.length < 3
    const saveDisabled = false;

    return (
      <div className="job-board-message-container">
        <div className="job-board-message-header">
          <h1>{this.getTitle()}</h1>
          <h2>{this.getTimeNow()}</h2>
        </div>
        <textarea className="job-board-message-textarea" onChange={this.handleChange} readOnly={action === 'update'}
                  value={logEntry.message} maxLength="1024"/>
        <div className="flex flex--center flex--between margin-t24">
          <div className="ui-popup-footer__left">
            {action === 'update' ? null : (
              <div className="flex flex--column">
                <h4 className="secondary margin-0">Send Email To:</h4>
                <div className="flex">
                  {SEND_EMAIL_CHECKBOXES.map(emailProperty => {
                    const checked = sendEmailCheckboxes.includes(emailProperty);
                    return (
                      <CheckBox checked={checked}
                                className="noselect margin-r16"
                                key={emailProperty}
                                innerStyle="none"
                                type={"tiny"}
                                text={intl.formatMessage({id: emailCheckboxesTranslates[emailProperty]})}
                                onChecked={() => setSendEmailCheckboxes(
                                  [...toggleArrayValue(sendEmailCheckboxes, emailProperty)]
                                )}/>
                    )
                  })}
                </div>
              </div>
            )}
          </div>
          <div className="ui-popup-footer__right">
            <button className="ui-button ui-button--blue" onClick={handleCancel}>
              <span className="ui-button-text">
                <FormattedMessage id={action === 'update' ? 'messageBox.buttons.close' : 'messageBox.buttons.cancel'}/>
              </span>
            </button>
            {action === 'update' ? null : (
              <button className={"ui-button ui-button--green margin-l16" + (saveDisabled ? " ui-button--disabled" : "")}
                      ref={btn => { this.saveBtn = btn; }}
                      onClick={this.handleSaveClick}
                      disabled={saveDisabled}>
                <span className="ui-button-text">
                  <FormattedMessage id="messageBox.buttons.save"/>
                </span>
              </button>
            )}
          </div>
        </div>
      </div>
    )
  }
}

JobBoardLog.propTypes = {
  logEntry: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  const {logEntryJob, sendEmailCheckboxes} = state.jobBoard;
  return {
    logPopupOpened: state.popups.jobBoard,
    action: state.jobBoard.logEntryJob.action,
    logEntry: logEntryJob.logEntry || {message: ''},
    status: logEntryJob.status,
    sendEmailCheckboxes,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleCancel: () => dispatch(toggleShowJobBoardLogEntryPopup(false)),
    changeJobStatus: () => dispatch(actions.changeJobStatus()),
    handleTextChange: (message) => dispatch(actions.basicAction(actionTypes.JOB_BOARD_LOG_UPDATE_TEXT, {message})),
    setSendEmailCheckboxes: (sendEmailCheckboxes) => dispatch(setSendEmailCheckboxes(sendEmailCheckboxes))
  }
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(JobBoardLog)
);

